// Batch 33 · B33-4 (owner decision) — one place to work and sign the final analytical review: 316(a) and R316(a) (the review
// engagement's form, B33-2) are opened on the Final analytical review screen (its sign-off bar and evaluation questions), never
// in the generic form dialog (a second editable copy of the procedures table). Same rule on the server: backend/form_links.py.
// PR 51 · P51-B2: on a REVIEW engagement a 316(a) it still holds opens the GENERIC form dialog read-only (sign-off bar + N/A
// action) — the review screen works on R316(a) there.
export const FAR_ROUTE = "/final-analytical-review";
export const AUDIT_FAR_FORM = "final_analytical_review";
export const REVIEW_FAR_FORM = "review_final_analytical_review";
export const FAR_FORM_IDS = new Set([AUDIT_FAR_FORM, REVIEW_FAR_FORM]);
export const isFarForm = (formId) => FAR_FORM_IDS.has(String(formId || ""));
export const isLegacy316a = (formId, engType) => String(formId || "") === AUDIT_FAR_FORM && engType === "review";
// true when the form opens on the Final analytical review screen (not in the form dialog)
export const opensFarScreen = (formId, engType) => isFarForm(formId) && !isLegacy316a(formId, engType);
